import { FC } from 'react';
import { CharitableGivingTab } from './CharitableGiving.types';
import { Assumptions } from './tabs/Assumptions/Assumptions';
import { Overview } from './tabs/Overview/Overview';

export const CHARITABLE_GIVING_TAB_MAP: Record<CharitableGivingTab, FC<any>> = {
  [CharitableGivingTab.Overview]: Overview,
  [CharitableGivingTab.Assumptions]: Assumptions,
};
